class ColumnSliderLoop extends HTMLElement {
  connectedCallback() {
    this.slideshow = this.querySelector('slideshow-component');
    this.scroller = this.querySelector('slideshow-slides');

    if (!this.slideshow || !this.scroller) return;

    this.prepareLoop();
    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());
    this.addEventListener('click', this.handleControlClick, true);
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  }

  disconnectedCallback() {
    this.stop();
    this.removeEventListener('click', this.handleControlClick, true);
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  }

  prepareLoop() {
    const cards = this.cards;
    if (cards.length < 2) return;

    customElements.whenDefined('slideshow-component').then(() => {
      if (!this.isConnected) return;
      this.start();
    });
  }

  get cards() {
    return [...this.scroller.querySelectorAll(':scope > .card')];
  }

  start() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || this.timer) return;

    const interval = Number(this.getAttribute('autoplay')) || 3000;
    this.timer = window.setInterval(() => this.advance(1), interval);
  }

  stop() {
    window.clearInterval(this.timer);
    this.timer = undefined;
  }

  advance = (direction) => {
    const cards = this.cards;
    if (cards.length < 2) return;

    if (window.matchMedia('(min-width: 750px)').matches) {
      const maxScroll = this.scroller.scrollWidth - this.scroller.clientWidth;
      if (maxScroll <= 1) return;
      const atEnd = direction > 0
        ? this.scroller.scrollLeft >= maxScroll - 1
        : this.scroller.scrollLeft <= 1;
      if (atEnd) {
        this.slideshow.select(direction > 0 ? 0 : cards.length - 1, undefined, { animate: false });
        return;
      }
    }

    const current = this.slideshow.current;
    const next = (current + direction + cards.length) % cards.length;
    const wrapping = current + direction !== next;
    this.slideshow.select(next, undefined, { animate: !wrapping });
  };

  handleControlClick = (event) => {
    const control = event.target.closest('.slideshow-control');
    if (!control) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    this.advance(control.classList.contains('slideshow-control--previous') ? -1 : 1);
  };

  handleVisibilityChange = () => (document.hidden ? this.stop() : this.start());
}

if (!customElements.get('column-slider-loop')) {
  customElements.define('column-slider-loop', ColumnSliderLoop);
}
